/**
 * Created by mykurisu on 2017/6/30.
 */
import React from 'react'
import axios from 'axios'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {Button, ActionSheet} from 'react-weui'
import ReactSwipe from 'react-swipe'
import Config from '../../config'
import {showBigAvatar, isPC, storage} from '../../utils'
import { Medal, MedalModal } from '../medal'
import '../../styles/liveroom/LiveroomSlideTopBar.css'
import LiveroomDefault0 from '../../images/liveroom/liveroom_defult_banner0.png'
import LiveroomDefault1 from '../../images/liveroom/liveroom_defult_banner1.png'
import LiveroomDefault2 from '../../images/liveroom/liveroom_defult_banner2.png'
import SlideGif from '../../images/liveroomSetting/liveroom-setting-slider-gif.gif'


class LiveroomSlideTopBar extends React.Component {

    constructor() {
        super();
        this.handleFollow = this.handleFollow.bind(this);
        this.handleActionSheet = this.handleActionSheet.bind(this);
        this.hendleLiveroomSlideClick = this.hendleLiveroomSlideClick.bind(this);
        this.handleEnterFansPage = this.handleEnterFansPage.bind(this);
        this.handleAvatarClick = this.handleAvatarClick.bind(this);
        this.handleSlideLeft = this.handleSlideLeft.bind(this);
        this.handleSlideRight = this.handleSlideRight.bind(this);
        this.state = {
            autoShow: false,
            liveroomFollowSheet: {
                menus: [{
                    label: '不再关注',
                    onClick: this.handleFollow
                }],
                actions: [{
                    label: '取消',
                    onClick: this.handleActionSheet
                }]
            },
            coverHeight: 0,
            slideBtn: false,
            isShowMedalModal: false,
            medalType: '',
            slidePoint: 0,
        };
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'liveroom_slide_enter'
        });
        this.setState({
            coverHeight: document.querySelector('div.page').clientWidth * 0.57
        })
    }

    handleActionSheet() {
        this.setState({autoShow: !this.state.autoShow})
    }

    handleFollow() {
        const {liveroom, subscribed} = this.props;
        if (liveroom.role.is_fans && subscribed) {
            axios.post(`api/liveroom/${liveroom.liveroom.id}/unfollow`).then((response) => {
                if (response.data.code === 0) {
                    this.props.dispatch({
                        type: 'LIVEROOM_UNSET_FANS',
                    });
                    this.context.page.showToast('已取消关注');
                    this.setState({autoShow: false})
                }
            });
        } else {
            this.props.dispatch({
                type: 'SHOW_FOLLOW_LIVEROOM',
                payload: {
                    liveroom: liveroom.liveroom
                }
            });
        }
    }

    hendleLiveroomSlideClick() {
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'liveroom_slideArea_click'
        });
    }

    handleEnterFansPage() {
        const {liveroom} = this.props;
        location.assign(`/liveroom/${liveroom.liveroom.id}/followers`)
    }

    handleSlideLeft() {
        this.refs.reactSwipe.prev();
    }

    handleSlideRight() {
        this.refs.reactSwipe.next();
    }

    handleAvatarClick() {
        const {liveroom} = this.props;
        let text = () => {
            return (
                <div className="liveroom-page-container">
                    <div className="liveroom-showalert">
                        <div className="liveroom-showalert-content">
                            <img src={liveroom.liveroom.small_avatar_url} alt="" onClick={e=>showBigAvatar(liveroom.liveroom.avatar_url)} />
                        </div>
                        <div className="liveroom-slidetop-content-main-type_showalert">
                            {
                                liveroom.liveroom.verify_type === 2 &&
                                <i className="iconfont verify-type-icon icon-yfv">
                                </i>
                            }
                            {
                                liveroom.liveroom.verify_type === 1 &&
                                <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv" >
                                </i>
                            }
                        </div>
                    </div>
                    <div className="liveroom-slidetop-content-main-name">
                        <p className="liveroom-showalert-p liveroom-showalert-p_gray">
                            <a onClick={liveroom.role.is_manager ? this.handleEnterFansPage : ''}>
                                {liveroom.stats_info.fans_count >= 10000
                                    ? (liveroom.stats_info.fans_count / 10000).toFixed(2) + '万+'
                                    : liveroom.stats_info.fans_count}
                                人关注
                            </a>
                            <span className="liveroom-slidetop-content-main-point">·</span>
                            {liveroom.stats_info.popular >= 10000
                                ? (liveroom.stats_info.popular / 10000).toFixed(2) + '万+'
                                : liveroom.stats_info.popular
                            }人气
                        </p>
                        <p className="liveroom-showalert-p">{liveroom.liveroom.name}</p>
                        <p className="liveroom-showalert-p">{liveroom.liveroom.description}</p>
                    </div>
                </div>
            )
        }
        this.context.page.showAlert(text(),'','');
    }

    handleDefaultImg() {
        if (isPC()){
            window.location.href = `${Config.ADMIN_BASE_URL}/config?liveroom_id=${this.props.liveroom.liveroom.id}`
        }else {
            let text = () => {
                return (
                    <div>
                        <img src={SlideGif} alt=""/>
                        <p style={{textAlign: 'left', marginTop: '20px'}}>
                            电脑浏览器打开讲师管理后台（{Config.ADMIN_BASE_URL}）在直播间管理中可上传轮播图
                        </p>
                    </div>
                )
            };
            this.context.page.showAlert(text(), '','直播间轮播图');
        }
    }

    onClickMedal (type) {
        this.setState({ isShowMedalModal: true, medalType: type })
    }

    renderSlides() {
        const {liveroom} = this.props;
        const {coverHeight, slidePoint} = this.state;
        let defaultBanner = null;
        switch (liveroom.liveroom.id % 3){
            case 0:
                defaultBanner = LiveroomDefault0;
                break;
            case 1:
                defaultBanner = LiveroomDefault1;
                break;
            case 2:
                defaultBanner = LiveroomDefault2;
                break;
        }
        if (liveroom.liveroom.banner_info.length === 0){
            return (
                <div onClick={() => liveroom.role.is_manager ? this.handleDefaultImg() : null} className="liveroom-slide-img"
                     style={{height: coverHeight + 'px', backgroundImage: `url(${defaultBanner})`}}>
                </div>
            )
        }else if (liveroom.liveroom.banner_info.length === 1){
            return (
                <a href={liveroom.liveroom.banner_info[0].link_url} key={liveroom.liveroom.banner_info[0].id}>
                    <div onClick={this.hendleLiveroomSlideClick} className="liveroom-slide-img"
                         style={{height: coverHeight + 'px', backgroundImage: `url(${liveroom.liveroom.banner_info[0].cover})`}}>
                    </div>
                </a>
            )
        }else {
            return (
                <div className="liveroom-page-slider-contain" style={{height: coverHeight + 'px', overflow: 'hidden'}}>
                    <ReactSwipe ref="reactSwipe" swipeOptions={{
                        speed: 400,
                        auto: 3000,
                        continuous: true,
                        callback: (index) => this.setState({
                            slidePoint: index
                        })
                    }}>
                        {liveroom.liveroom.banner_info.map((banner) => (
                            <a href={banner.link_url} key={banner.id}>
                                <div onClick={this.hendleLiveroomSlideClick} className="liveroom-slide-img"
                                     style={{height: coverHeight + 'px', backgroundImage: `url(${banner.cover})`}}>
                                </div>
                            </a>
                        ))}
                    </ReactSwipe>
                    <div className="liveroom-page-slider-contain_btn">
                        <div className="liveroom-page-slider-contain_btn-left" onClick={this.handleSlideLeft}>
                            <i className="icon iconfont icon-shouqi"></i>
                        </div>
                        <div className="liveroom-page-slider-contain_btn-right" onClick={this.handleSlideRight}>
                            <i className="icon iconfont icon-shouqi"></i>
                        </div>
                    </div>
                    <div className="liveroom-page-slider-contain_point">
                        {liveroom.liveroom.banner_info.map((banner, i) => (<span key={i} className={slidePoint === i ? 'liveroom-page-slider-contain_point-active' : ''}></span>))}
                    </div>
                </div>
            )
        }
    }

    onClickMedalClose () {
        storage.setItem('liveroom_shuangqian_medal_modal_show', true)
        this.setState({ isShowMedalModal: false })
    }

    onClickCertificate () {
        storage.setItem('liveroom_shuangqian_medal_modal_show', true)
    }

    render() {
        const {liveroom, subscribed} = this.props;
        const {liveroomFollowSheet, autoShow, coverHeight} = this.state;
        let isShowMedalModal = this.state.isShowMedalModal
        let medalType = this.state.medalType
        const hasTT = liveroom.liveroom.badges.some(item => item === 'tt_achieve')
        if (!storage.getItem('liveroom_shuangqian_medal_modal_show') && this.props.liveroom.role.is_manager && hasTT) {
            isShowMedalModal = true
            medalType = 'tt_achieve'
        }
        return(
            <div className="liveroom-page-container">
                <ActionSheet menus={liveroomFollowSheet.menus} actions={liveroomFollowSheet.actions} show={autoShow}
                             onRequestClose={this.handleActionSheet}/>
                {coverHeight !== 0 &&
                this.renderSlides()
                }
                <div className="liveroom-slidetop-content">
                    <div className="liveroom-slidetop-content-main">
                        <div className="liveroom-slidetop-content-main-iconcontent" onClick={this.handleAvatarClick}>
                            <div className="liveroom-slidetop-content-main-icon">
                                <div className="liveroom-slidetop-content-main-type">
                                    {
                                        liveroom.liveroom.verify_type === 2 &&
                                        <i className="iconfont verify-type-icon icon-yfv">
                                        </i>
                                    }
                                    {
                                        liveroom.liveroom.verify_type === 1 &&
                                        <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv" >
                                        </i>
                                    }
                                </div>
                                <img src={liveroom.liveroom.small_avatar_url} alt=""/>
                            </div>
                        </div>
                        <div className="liveroom-slidetop-content-main-name">
                            <p>
                                <span onClick={this.handleAvatarClick} className='wk-pointer-hand'>{liveroom.liveroom.name}</span>
                                {
                                    liveroom.liveroom.badges.map(item => (
                                        <Medal
                                            type={item}
                                            onClickMedal={e => this.onClickMedal(item)}
                                            style={{marginTop: '4px', width: '18px'}}
                                            key={item}
                                        />
                                    ))
                                }
                            </p>
                            <p>
                                <a onClick={liveroom.role.is_manager ? this.handleEnterFansPage : ''}>
                                    {liveroom.stats_info.fans_count >= 10000
                                        ? (liveroom.stats_info.fans_count / 10000).toFixed(2) + '万+'
                                        : liveroom.stats_info.fans_count}
                                    人关注
                                </a>
                                <span className="liveroom-slidetop-content-main-point">·</span>
                                {liveroom.stats_info.popular >= 10000
                                    ? (liveroom.stats_info.popular / 10000).toFixed(2) + '万+'
                                    : liveroom.stats_info.popular
                                }人气

                            </p>
                        </div>
                    </div>
                    {!liveroom.role.is_manager ?
                        <div className="liveroom-slidetop-content-btn">
                            {(liveroom.role.is_fans && subscribed) ?
                                <Button size="small" className="liveroom-slidetop-content-btn_gray" onClick={this.handleActionSheet}>已关注</Button>
                                :
                                <Button size="small" onClick={this.handleFollow}>关注</Button>
                            }
                        </div>
                        :
                        (liveroom.liveroom.verify_type === 0 ?
                            <div className="liveroom-verify" onClick={() => location.assign(`/liveroom/${liveroom.liveroom.id}/verify`)}>
                                <p className="liveroom-verify__content">认证</p>
                                <span className="liveroom-verify__border"/>
                            </div>
                            :
                            <div className="liveroom-unverify" onClick={() => location.assign(`/liveroom/${liveroom.liveroom.id}/verify`)}>
                                <p className="liveroom-verify__content">已认证</p>
                                <span className="liveroom-verify__border"/>
                            </div>
                        )
                    }
                </div>
                <MedalModal
                    show={isShowMedalModal}
                    onClickClose={() => this.onClickMedalClose()}
                    isShowBtn={this.props.liveroom.role.is_manager}
                    type={medalType}
                    liveroomId={this.props.liveroom.liveroom.id}
                    onClickCertificate={() => this.onClickCertificate()}
                />
            </div>
        )
    }
}

LiveroomSlideTopBar.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    liveroom: state.liveroom,
    subscribed: state.account.subscribed,
}))(LiveroomSlideTopBar)



// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomSlideTopBar.js